import { useOFACStatus } from '@/contexts/OFACContext';
import { useTOSStatus } from '@/contexts/TOSContext';
import { useChainEnv } from '@/utils/hooks/useChainEnv';

export function useIsPermittedToBridge() {
  const { isTosAccepted } = useTOSStatus();
  const { isOFACAllowed, isOFACAllowedLoading } = useOFACStatus();
  const chainEnv = useChainEnv();
  const isMainnet = chainEnv === 'mainnet';
  const isPermittedToBridge =
    (isMainnet && isTosAccepted && isOFACAllowed && !isOFACAllowedLoading) || !isMainnet;

  return isPermittedToBridge;
}
